<ng-container *ngIf="fantasyHistory$ | async as fantasyHistory">
  <ng-container *ngIf="fantasyHistory.length > 0; else noPlayerHistory">
    <div class="card bg-primary rounded">
      <ng-container *ngFor="let item of fantasyHistory">
        <fgb-fantasy-history-list-item [fantasyHistoryItem]="item"></fgb-fantasy-history-list-item>
      </ng-container>
    </div>
  </ng-container>
  <ng-template #noPlayerHistory>
    <div class="no-items w-100 text-center border-primary bg-primary text-white rounded">
      <div class="text-center font-size-14">{{ 'pick.player.history.placeholder.description' | translate }}</div>
    </div>
  </ng-template>
</ng-container>
